import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { Slider, SvgIcon } from "@mui/material";
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import ArrowDropDownIcon from '../../../../icons/arrow_drop_down.svg?react'
import './HeaderStepper.scss';

function HeaderProgressTracker(props) {
    var title = props.title || "Compare and Apply";
    var headerProductsText = props.headerProductsText || '';
    var phone = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.phone;
    var dateTime = 'Monday - Friday 8:00 AM - 6:00 PM ET';

    return (
        <div className={`header-stepper ${(props.whiteBg || props.showOnlyProgressTracker) ? 'white-background' : ''} ${props.hideProgressTracker ? 'increase-contrast' : ''} ${props.customClassNames}`} >
            <Container fluid className={`head ${props.showOnlyProgressTracker ? "boxShadow" : "light-background-boxShadow"} ${props.currentPageTitle ? 'header-content' : ''} ${props.hidden ? 'd-none' : ''} ${props.showContainer ? '' : 'mb-0'} ${!props.hideProgressTracker ? 'extend-headerTracker' : ''}`}>
                {props.showOnlyProgressTracker ?
                    <ProgressTracker {...props} />
                    :
                <Container className={props.hideProgressTracker ? 'h-100' : ''}>
                    {props.currentPageTitle && <Row>
                                                <div className={`headerColor pt-4 mb-2`}>{headerProductsText}</div>
                                            </Row>
                    }
                    {props.hideMainTitle ? null : (
                        <Row className={props.hideProgressTracker ? 'h-100' : ''}>                           
                         {props.isBreadCrumb ?
                             <Col className="d-flex align-items-center h1-wrapper px-0">
                             <b>{props.breadCrumbLinks.name} &nbsp; / &nbsp; {props.breadCrumb}</b>
                             </Col>:
                            <Col className={props.headerProductsText ? `d-flex align-items-center title-wrapper ${props.showCustomizeProgressTracker ? 'custom-term-wrapper' : ''}` : 'd-flex align-items-center h1-wrapper'}>
                                {props.showCustomizeProgressTracker ? <h3 className='m-0'>{title}</h3> : <h1 className= {`${props.isblackHeaderText && 'black-text'}`}>{title}</h1>}
                            </Col>
                        }                            
                            {props.displayHelpText ?
                                <Col className="headerPhone">
                                    <div>
                                        <span className='account-phoneText'>We're here to help: </span><span className="headerPhoneColor">{phone}</span>
                                    </div>
                                    <div className="weekDays">
                                        {dateTime}
                                    </div>
                                </Col>
                                : ''
                            }
                        </Row>
                    )}


                    {!props.hideProgressTracker &&
                        <ProgressTracker {...props} />
                    }

                </Container>
                }
            </Container>

            <Container fluid={props.fullWidth} className={`${props.showOnlyProgressTracker ? 'pb-4' :'page-content'} ${props.showContainer ? 'products' : 'p-0'} ${props.step === 1 && !props.showOnlyProgressTracker ? 'basic-step' : ''}`}>
                {props.children}
            </Container>
        </div >
    );
}

function ProgressTracker(props) {

    let percentCompleted = ((props.step - 0.5) / props.totalSteps) * 100;

    if (props.lastStep) {
        percentCompleted = 100;
    }

    if (props.percent && props.step !== 3) {
        percentCompleted = props.percent + 17;
    } else if (props.percent) {
        percentCompleted = props.percent + 2;
    }

    const hideStepText = props.hideStepText || false;

    return (
        <Row className={`headerProgressTrackerRow ${props.showOnlyProgressTracker ? 'm-2' : ''}`}>
            <Col className="ps-0 pe-0">
                <div className={`headerProgressTracker bg-white rounded ${props.currentPageTitle ? 'progressTracker-shadow' : ''}`}>
                    <h2 className="headerProgressTrackerTitle">
                        {props.stepName}
                    </h2>
                    <p className="headerProgressSteps">
                        {hideStepText ? '' : props.displayStepTitleWithArrow ? <b style={{ color: "#000" }}>Step {props.step} of {props.totalSteps} <SvgIcon component={ArrowDropDownIcon} /></b> : `Step ${props.step} of ${props.totalSteps} `}
                    </p>
                    <Slider
                        value={percentCompleted}
                        aria-labelledby="discrete-slider"
                        valueLabelDisplay="off"
                        step={100 / props.totalSteps}
                        marks
                        min={0}
                        max={100}
                        className={`slider-progress primary-color`}
                        disabled
                    />
                </div>
            </Col>
        </Row >
    )
}

export { HeaderProgressTracker }

HeaderProgressTracker.propTypes = {
    hideProgressTracker: PropTypes.bool,
    hidden: PropTypes.bool,
    title: PropTypes.string,
    whiteBg: PropTypes.bool,
    lastStep: PropTypes.bool,
    customClassNames: PropTypes.string
}

ProgressTracker.propTypes = {
    stepName: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired,
}
